<template lang="pug">
  el-dialog(
    :visible="true"
    :title="$t('firmwares.actions.add')"
    @close="hideAddFirmwareDialog"
  )
    .add-firmware
      el-upload(
        drag
        action=""
        :auto-upload="false"
        :on-change="handleFileChange"
        :limit="1"
        accept=".bin"
      )
        i.el-icon-upload
        .el-upload__text {{ $t('firmwares.actions.upload_hint') }}
      el-row.text-center
        el-button.dark-green-btn.mt-5.pop-up-btn(
          @click="handleAddFirmware"
          :loading="loading"
          :disabled="!selectedFile"
        ) {{ $t('common.add') }}
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  name: "AddFirmware",

  props: {
    siteId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedFile: null,
      loading: false,
    };
  },

  methods: {
    ...mapActions("firmware", ["addFirmware"]),
    ...mapMutations("dialog", ["hideAddFirmwareDialog"]),
    ...mapMutations("firmware", ["setShouldFetchFirmwares"]),

    handleFileChange(file) {
      this.selectedFile = file.raw;
    },

    handleAddFirmware() {
      this.loading = true;

      this.addFirmware({ siteId: this.siteId, file: this.selectedFile })
        .then(() => {
          this.hideAddFirmwareDialog();
          this.selectedFile = null;
          this.setShouldFetchFirmwares(true);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
